<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InputXrfInspForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InputXrfInspForm from '@/components/organisms/terminal/form/InputXrfInspForm'

export default {
  name: 'InputXrfInspPage',

  components: {
    InputXrfInspForm,
  },
}
</script>
